import React from 'react';

import { ButtonItem, Section } from '@atlaskit/menu';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import type { SpaceRole } from '../../model/space-roles-types.ts';

const navContainerStyles = xcss({
	width: '202px',
});

export const RoleListButtons = ({
	systemRoles,
	customRoles,
	activeRoleId,
	setActiveRoleId,
}: {
	systemRoles: SpaceRole[];
	customRoles?: SpaceRole[];
	activeRoleId: string;
	setActiveRoleId: (roleId: string) => void;
}) => {
	return (
		<Box xcss={navContainerStyles}>
			<Section>
				{[...systemRoles, ...(customRoles || [])].map((role) => (
					<ButtonItem
						key={role.id}
						isSelected={role.id === activeRoleId}
						onClick={() => setActiveRoleId(role.id)}
					>
						{role.name}
					</ButtonItem>
				))}
			</Section>
		</Box>
	);
};
